import { addSmartTask } from './getSmartTodosOrRemindersForItem.locstring.json';
import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import { FeatureNames } from 'owa-mail-smart-pill-features';
import { SmartTaskSuggestion } from 'owa-mail-store';
import { initializeSmartPillLogData, SmartPillData, SmartPillLogData } from 'owa-smart-pill';
import { lazyOpenTasksView } from 'owa-time-panel';
import { isTimePanelWithToDoFeaturesAvailable } from 'owa-time-panel-bootstrap';
import { lazyInitializeQuickAdd } from 'owa-time-panel-todo';

export default function createSmartTodoPillData(
    smartTodo: SmartTaskSuggestion,
    itemId: string,
    displayText: string,
    index: number
): SmartPillData {
    const logData: SmartPillLogData = initializeSmartPillLogData(
        FeatureNames.SmartTodo,
        displayText
    );
    logData.mainPayload.confidenceScore = smartTodo.confidenceScore;
    logData.mainPayload.EID = smartTodo.entityId;

    return {
        ariaLabel: loc(addSmartTask),
        featureName: FeatureNames.SmartTodo,
        icon: { iconName: ControlIcons.ToDoLogoOutline },
        onClick: () => {
            openTasksView(smartTodo.description, itemId, smartTodo.entityId);
        },
        logData: logData,
        index: index,
        text: displayText,
        toolTip: displayText,
        confidenceScore: smartTodo.confidenceScore,
    };
}

/**
 * Opens the Time Panel to Tasks view and forwards the email information
 */
function openTasksView(subject: string, itemId: string, extractionId: string) {
    if (isTimePanelWithToDoFeaturesAvailable()) {
        lazyOpenTasksView.importAndExecute('SmartTask');

        // pre-populate Task panel with detected task intent (if any)
        if (subject && itemId) {
            lazyInitializeQuickAdd.importAndExecute(subject, itemId, extractionId);
        }
        return;
    }
}
